import React from "react";
import Input from "./input";
import ButtonIcon from "./buttonIcon";
import { Search } from "antd";

export default props => (
    <div className="search-group">
        <Input label={props.placeholder} value={props.value} onChange={(e) => props.onChange(e)}/>
        <ButtonIcon className={`btn-search ${props.className}`} text="Limpar Busca" type={props.type} callback={() => props.callback()}
                  label={props.buttonLabel}/>
    </div>
)

